import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useFirebaseApp } from 'reactfire'
import 'firebase/analytics'
import { useEffect } from 'react'
import 'firebase/database'
import { getInfo } from '../redux/actionCreators'
import store from '../redux/store'

const Header=()=>{
  let firebase=useFirebaseApp()
  firebase.analytics()
  let database=firebase.database()

  useEffect(() => {
    let ref=database.ref()
    ref.on('value',(snap)=>{
      store.dispatch(getInfo(snap.val()))
    })
  }, [database])
  
  let menu

  let body=document.getElementById('root')
  
  const openMenu=e=>{
    menu=document.getElementById('menu')
    menu.classList.add('menu-active')
  }
  
  body.addEventListener('click',()=>{
    if (menu){
      menu.classList.remove('menu-active')
    }
  })
  
  const getData=()=>{
    let header=document.querySelector('header')
    let data=header.getBoundingClientRect()
    let height=data.height
    document.documentElement.style.setProperty('--header-height',`${height}px`)
    if (document.querySelector('.sub-menu')){
      let subMenu=document.querySelector('.sub-menu')
      let subData=subMenu.getBoundingClientRect()
      let subHeight=subData.height
      document.documentElement.style.setProperty('--projectMenu-height',`${subHeight+height}px`)
    }
  }

  body.addEventListener('resize',()=>{
    getData()
  })

  
  return <header onLoad={getData.bind(this)}>
    <div className="logo-container">
    <Link to="/"><img src="logo-luis.svg" alt="logo-luis" className="logo-image"/></Link>
    </div>
    <div className="menu-container">
      <div className='menu-icon' onClick={openMenu.bind(this)}>
        <img src="media/icons/menu.svg" alt="icono-menu" className="menu-image"/>
      </div>
      <div className='menu' id='menu'>
        <ul className="menu-list">
          <NavLink activeClassName='menu-item-active' className='menu-item' exact to='/'><li>Inicio</li></NavLink>
          <div className="line"></div>
          <NavLink activeClassName='menu-item-active' className='menu-item' to='/proyectos'><li>Proyectos</li></NavLink>
          <div className="line"></div>
          <NavLink activeClassName='menu-item-active' className='menu-item' to='/contacto'><li>Contacto</li></NavLink>
          <div className="line"></div>
        </ul>
      </div>
    </div>
  </header>
}

export default Header
